import React from 'react';
import { Button, Space } from 'antd';
import { CalendarOutlined, TableOutlined } from '@ant-design/icons';

const Header = ({ currentView, onViewChange }) => {
  return (
    <div className="bg-white/20 backdrop-blur-md text-white py-3 shadow-lg border-b border-white/20">
      <div className="container mx-auto px-4 flex items-center justify-between">
        <h1 className="text-2xl md:text-3xl font-bold text-shadow-lg">
          AiQiji课程表制作
        </h1>
        
        <Space size="middle">
          <Button
            type={currentView === 'schedule' ? 'primary' : 'default'}
            size="middle"
            icon={<CalendarOutlined />}
            onClick={() => onViewChange('schedule')}
            className={currentView === 'schedule' ? 'border-blue-400 bg-blue-500' : 'bg-white/10 border-white/30 text-white hover:bg-white/20'}
          >
            课程表制作
          </Button>
          <Button
            type={currentView === 'seating' ? 'primary' : 'default'}
            size="middle"
            icon={<TableOutlined />}
            onClick={() => onViewChange('seating')}
            className={currentView === 'seating' ? 'border-blue-400 bg-blue-500' : 'bg-white/10 border-white/30 text-white hover:bg-white/20'}
          >
            座位排序
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default Header;
